export default {
  dayOfWeek () {
    return this.$dayOfWeek(this.schedule.date, 'DD/MM/YYYY')
  },
  dayOfWeekTransfer () {
    return this.$dayOfWeekTransfer(this.schedule.transfer.date, 'DD/MM/YYYY')
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/components/reverser/resources/computed.js